var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromos43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4781",
    "data-name": "Group 4781",
    transform: "translate(22951 -4316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4365",
    "data-name": "Rectangle 4365",
    width: 24,
    height: 24,
    transform: "translate(-22951 4316)",
    fill: "none",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773",
    transform: "translate(-23283.699 3555.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M1003.213,1205.236l.107,11.661a1.189,1.189,0,0,0,1.19,1.19h.071a1.188,1.188,0,0,0,.743-.26l6.217-4.126,6.506,4.13a1.192,1.192,0,0,0,.738.256h0a1.19,1.19,0,0,0,1.19-1.19l-.107-11.661a6.2,6.2,0,0,0-6.2-6.2h-4.247A6.2,6.2,0,0,0,1003.213,1205.236Z",
    transform: "translate(-666.978 -436.387)",
    fill: "rgba(0,255,238,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M817.339,1224.505l.562,1.138a.8.8,0,0,0,.6.438l1.256.183a.8.8,0,0,1,.443,1.366l-.909.886a.8.8,0,0,0-.23.709l.214,1.25a.8.8,0,0,1-1.162.844l-1.123-.59a.8.8,0,0,0-.745,0l-1.123.59a.8.8,0,0,1-1.162-.844l.215-1.25a.8.8,0,0,0-.23-.709l-.909-.886a.8.8,0,0,1,.444-1.366l1.255-.183a.8.8,0,0,0,.6-.438l.561-1.138A.8.8,0,0,1,817.339,1224.505Z",
    transform: "translate(-472.006 -457.175)",
    fill: "#0fe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromos43A0);
export default __webpack_public_path__ + "static/media/promos43a0.636c9d9ca08d8cb409f887d55217630f.svg";
export { ForwardRef as ReactComponent };